<div
  #messageContainer
  class="message"
  autocomplete="off"
  autocorrect="off"
  spellcheck="true"
  aria-expanded="false"
  aria-autocomplete="list"
  aria-multiline="true"
  aria-label="Message"
  dir="auto"
  contenteditable="true"
  role="textbox"
  (input)="onInput($event.target.innerText)"
  (paste)="onPaste($event)"
  [attr.placeholder]="placeholder"
></div>
